/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Ad_Job_TitleInputs */



/**
* | output |
* | --- |
* | "Delete AD Job" |
*
* @param {Delete_Ad_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_ad_job_title = /** @type {((inputs?: Delete_Ad_Job_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Ad_Job_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l'offre d'emploi AD")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Auftrag löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina processo AD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить задание AD")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar trabajo de AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除 AD 作业")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADジョブの削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD जॉब हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir tarefa de anúncio")
	return /** @type {LocalizedString} */ ("Delete AD Job")
});